module.exports = __webpack_public_path__ + "static/img/1_3_3.f7b3bf10.jpg";